// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__COH_-","location":"Header_location__1d5bP"};